/* ── Tarjetas con varias opciones (Anillo Duala, Color + Talla) ─────────────
 * Alba, 20-10 14:18. Se pide por fases: primero el color y, una vez elegido,
 * aparece la talla. Las tallas agotadas en ese color salen tachadas y
 * "Añadir" solo se activa con todo elegido. Vive aquí, en un JS que carga
 * siempre, porque el script en línea del snippet no corría en las tarjetas
 * que se pintan después de cargar la página. Va en fase de captura y corta la
 * propagación para que el manejador antiguo del snippet no actúe dos veces. */
(function () {
  if (window.__creuQaFases) return;
  window.__creuQaFases = true;
  window.__creuQaMulti = true;
  // Textos de window.CreuT (layout); el literal es el fallback en español.
  const t = (k, fallback) => (window.CreuT && window.CreuT[k]) || fallback;

  function datos(host) {
    var tag = host.querySelector('[data-creu-qa-data]');
    try { return JSON.parse(tag.textContent); } catch (e) { return null; }
  }
  function grupos(host) { return Array.prototype.slice.call(host.querySelectorAll('[data-creu-qa-group]')); }
  function elegido(host) {
    var c = {};
    grupos(host).forEach(function (g) {
      var a = g.querySelector('.is-active');
      if (a) c[a.dataset.index] = a.dataset.value;
    });
    return c;
  }
  function resolver(host) {
    var d = datos(host); if (!d) return null;
    var c = elegido(host);
    if (Object.keys(c).length < grupos(host).length) return { incompleto: true };
    for (var i = 0; i < d.variants.length; i++) {
      var v = d.variants[i], ok = true;
      for (var k = 0; k < v.o.length; k++) {
        var want = (k in c) ? c[k] : d.default[k];
        if (String(v.o[k]) !== String(want)) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }
  function pintar(host) {
    var d = datos(host); if (!d) return;
    var gs = grupos(host), abierto = true;
    gs.forEach(function (g, gi) {
      g.style.display = abierto ? '' : 'none';
      if (!g.querySelector('.is-active')) abierto = false;
      // Valores sin ninguna variante disponible con lo ya elegido antes: tachados.
      var previo = {};
      gs.slice(0, gi).forEach(function (pg) {
        var a = pg.querySelector('.is-active'); if (a) previo[a.dataset.index] = a.dataset.value;
      });
      g.querySelectorAll('[data-creu-qa-opt]').forEach(function (b) {
        var hay = d.variants.some(function (v) {
          if (!v.a || String(v.o[b.dataset.index]) !== String(b.dataset.value)) return false;
          for (var k in previo) if (String(v.o[k]) !== String(previo[k])) return false;
          return true;
        });
        b.classList.toggle('is-soldout', !hay);
        b.style.textDecoration = hay ? '' : 'line-through';
        b.style.opacity = hay ? '' : '0.45';
      });
    });
    var btn = host.querySelector('[data-creu-qa-multi-add]');
    if (!btn) return;
    btn.style.display = (gs.length && !gs[gs.length - 1].querySelector('.is-active')) ? 'none' : '';
    var v = resolver(host);
    if (!v || v.incompleto) { btn.disabled = true; btn.textContent = t('creu.tienda.add', 'Añadir'); return; }
    if (!v.a) { btn.disabled = true; btn.textContent = t('creu.tienda.sold_out', 'Agotado'); return; }
    btn.disabled = false; btn.textContent = t('creu.tienda.add', 'Añadir');
  }

  function prepararTodos() {
    document.querySelectorAll('[data-creu-qa-multi]').forEach(function (h) {
      if (h.__creuFases) return;
      h.__creuFases = true;
      pintar(h);
    });
  }
  document.addEventListener('DOMContentLoaded', prepararTodos);
  new MutationObserver(prepararTodos).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', function (e) {
    var tg = e.target.closest('[data-creu-qa-multi] [data-creu-qa-toggle]');
    if (tg) { pintar(tg.closest('[data-creu-qa-multi]')); return; }

    var opt = e.target.closest('[data-creu-qa-multi] [data-creu-qa-opt]');
    if (opt) {
      e.preventDefault(); e.stopPropagation();
      var host = opt.closest('[data-creu-qa-multi]');
      var g = opt.closest('[data-creu-qa-group]');
      g.querySelectorAll('[data-creu-qa-opt]').forEach(function (b) { b.classList.remove('is-active'); });
      opt.classList.add('is-active');
      // Al cambiar una fase se borran las elecciones de las siguientes.
      var gs = grupos(host), i = gs.indexOf(g);
      gs.slice(i + 1).forEach(function (n) {
        n.querySelectorAll('.is-active').forEach(function (b) { b.classList.remove('is-active'); });
      });
      pintar(host);
      return;
    }

    var add = e.target.closest('[data-creu-qa-multi] [data-creu-qa-multi-add]');
    if (add) {
      e.preventDefault(); e.stopPropagation();
      if (add.disabled) return;
      var h = add.closest('[data-creu-qa-multi]');
      var v = resolver(h);
      if (!v || v.incompleto || !v.a) return;
      var panel = h.querySelector('[data-creu-qa-options]');
      addToCartMulti(v.id, add).then(function () {
        if (panel) panel.hidden = true;
        var tg = h.querySelector('[data-creu-qa-toggle]');
        if (tg) tg.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('creu-qa-abierto');
      });
    }
  }, true);

  function addToCartMulti(id, btn) {
    btn.disabled = true; btn.textContent = t('creu.tienda.adding', 'Añadiendo…');
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:update', { detail: { data: { variantId: id } } }));
        return window.CreuCart ? window.CreuCart.refresh().then(function () { window.CreuCart.open(); }) : null;
      })
      .catch(function () { btn.textContent = t('creu.tienda.error', 'Error'); })
      .then(function () { btn.disabled = false; btn.textContent = t('creu.tienda.add', 'Añadir'); });
  }
})();
